module.exports = __webpack_public_path__ + "static/result_yongin-fbf4112fceae9b57648029e80a65e84a.png";